import { defineGameCard } from '../authoring/index.js';
import { slimeDependencies, trail } from './slime-helpers.js';
export const JellyBastionCard = defineGameCard({
    id: 'jelly_bastion',
    gameplay: { type: 'UNIT', cost: 4, baseStats: { attack: 1, health: 9 }, traits: ['SLIME'] },
    presentation: {
        name: 'Желейный бастион',
        description: 'След 1.',
        glyph: {
            colors: ['#10213A', '#5E984F', '#74AD4C', '#96C653', '#3A624D'],
            rows: [
                '....................',
                '........11....1.....',
                '.......1231..131....',
                '........121..121....',
                '.........131111.....',
                '........14444241....',
                '.......1444444421...',
                '......12444141441...',
                '.....113344444441...',
                '...112233334444331..',
                '..1343333333333331..',
                '..13333333433334321.',
                '.133233344444444431.',
                '1223323334444444441.',
                '1232333333444444331.',
                '.1222333333344333221',
                '.1522222223333332221',
                '15555222252222225551',
                '.111111111111111111.',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeDependencies(),
    abilities: [trail()],
    ui: { mechanics: ['trail', 'slime_residue'] },
});
//# sourceMappingURL=jelly_bastion.js.map